var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      ref: "elTable",
      staticStyle: { width: "100%" },
      attrs: { border: "", data: _vm.tableData, "max-height": "500px" },
    },
    [
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "trackingId",
          label: this.$t("OrdinaryOrderMix.LogiTab.Tracking"),
          "min-width": "125",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "articleId",
          label: this.$t("OrdinaryOrderMix.LogiTab.Parcel"),
          "min-width": "125",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "lastStatus",
          label: this.$t("OrdinaryOrderMix.LogiTab.Status"),
          "min-width": "141",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.getLastStatusText(row.lastStatus)))]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "logisticsBusinessName",
          label: this.$t("OrdinaryOrderMix.LogiTab.Company"),
          "min-width": "125",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "logisticsCompany",
          label: this.$t("OrdinaryOrderMix.LogiTab.Type"),
          "min-width": "125",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "logisticsCreateTime",
          label: this.$t("OrdinaryOrderMix.LogiTab.Time"),
          "min-width": "125",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  _vm._s(
                    _vm._f("timeFilters")(
                      scope.row.logisticsCreateTime,
                      scope.row.logisticsCreateTime
                    )
                  )
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "lastLogisDate",
          label: _vm.$t("OrdinaryOrderMix.LogiTab.updateTime"),
          "min-width": "150",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [
                _vm._v(
                  _vm._s(
                    _vm._f("timeFilters")(row.lastLogisDate, row.lastLogisDate)
                  )
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "lastLocation",
          label: _vm.$t("OrdinaryOrderMix.LogiTab.trackingStatus"),
          "min-width": "180",
          "show-overflow-tooltip": "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }